class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("cart-notification");
    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.viewCartButton = document.querySelector('.js-cart-notification-view-cart');
    this.body = document.querySelector('body');

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );
    this.viewCartButton.addEventListener('click', event => this.viewCart(event));
  }

  open() {  
    this.notification.parentElement.classList.add("active");
    this.body.classList.add("minicart__open");

    const gorgiasButton = document.getElementById('gorgias-chat-messenger-button');
    if (gorgiasButton) gorgiasButton.style.display = 'none';

    const handleTransitionEnd = () => {
      this.notification.focus();
      window.trapFocus(this.notification);
      document.body.classList.add('overflow-hidden--tablet-down');
    }

    this.notification.addEventListener(
      "transitionend",
      handleTransitionEnd,
      { once: true }
    );

    setTimeout(handleTransitionEnd, 300);

    document.body.addEventListener('touchstart', this.onBodyClick, { passive: false });
    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    this.notification.parentElement.classList.remove("active");
    this.body.classList.remove("minicart__open");

    document.body.removeEventListener('touchstart', this.onBodyClick);
    document.body.removeEventListener("click", this.onBodyClick);

     const gorgiasButton = document.getElementById('gorgias-chat-messenger-button');
     if (gorgiasButton) gorgiasButton.style.display = '';

    window.removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden--tablet-down');
  }

  renderContents(parsedState, options = {}) {
    this.productId = Array.isArray(parsedState.items)
      ? parsedState.items[0].id
      : parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const target = document.getElementById(section.id);
      if (!target) return;

      if (section.id === "cart-notification-products" && options.productsHTML != null) {
        target.innerHTML = options.productsHTML;
        return;
      }

      const html = this.getSectionInnerHTML(
        parsedState.sections[section.section],
        section.selector
      );
      if (html != null) target.innerHTML = html;
    });

    // options.productsHTML is the honest test for "caller already built the
    // toast body itself" (e.g. the B2B order form) — window.B2B is true for
    // every B2B customer, including on the regular PDP add form, so gating on
    // it here hid every line past the first for B2B shoppers everywhere.
    if (Array.isArray(parsedState.items) && options.productsHTML == null) {
      parsedState.items.slice(1).forEach((item) => {
        this.productId = item.id;
        const section = this.getSectionsToRender()[0];
        const target = document.getElementById(section.id);
        if (!target) return;
        const html = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
        if (html != null) target.insertAdjacentHTML("beforeend", html);
      });
    }
    if (this.header) this.header.reveal();
    this.open();
    window.convertCurrency(this);
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-products",
        section: "cart-notification-products",
        selector: `[id="cart-notification-product-${this.productId}"]`,
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
      },
      {
        id: "cart-notifications-wrapper",
        section: "cart-notifications",
      },
      // 'mini-cart-upsell' removed: its toast container is commented out in
      // cart-notification.liquid, so requesting it only server-rendered + discarded
      // the upsell on every add. Re-add this entry + uncomment the container to re-enable.
      // {
      //   id: "cart-notification-spend-tracker",
      //   section: "spend-tracker",
      // },
      // {
      //   id: "cart-notification-shipping",
      //   section: "shipping-notifications",
      // },
      // {
      //   id: "cart-notification-gift-selector",
      //   section: "gift-selector-tracker",
      // },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    // Returns null (never throws) on a missing section or selector miss. The
    // B2B add path deliberately omits cart-notification-products from the
    // sections it requests, so parsedState.sections[section] is undefined
    // even though the DOM node still exists — a hard requirement, not just
    // defensive cleanup.
    if (html == null) return null;
    const node = new DOMParser().parseFromString(html, "text/html").querySelector(selector);
    return node ? node.innerHTML : null;
  }

  handleBodyClick(event) {
    const target = event.target;
    if (target !== this.notification && !this.notification.contains(target)) {
      event.type === 'touchstart' && event.preventDefault();
      const disclosure = target.closest("details-disclosure");
      this.activeElement = disclosure
        ? disclosure.querySelector("summary")
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  viewCart(event) {
    event.preventDefault();
    this.close();
    
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.open();
      return;
    }
    window.location.href = window.routes.cart_url;
  }
}

customElements.define("cart-notification", CartNotification);